import { history } from 'store/configureStore';
import { isInnerPage } from 'shared/utils/isInnerPage';
import { defaultApplicationLanguage } from 'locales/_languages';
import defaultPageName from 'modules/auth/constants/defaultPageName';
import config from 'config';
import createAction from './';
import { getCurrentLanguage } from '../selectors/language';

export const LANGUAGE_CHANGE = createAction('LANGUAGE_CHANGE');

export const selectLanguage = (language) => (dispatch, getState) => {
  if (!language) return;

  let { router: { location: { pathname } } } = getState();
  const currentLanguage = getCurrentLanguage();

  if (pathname === '/') {
    pathname = `/${ defaultApplicationLanguage }${ defaultPageName }`;
  }

  const path = pathname.replace(currentLanguage, language);

  if (currentLanguage !== language) {
    const pageIsInner = isInnerPage(pathname);
    const location = pageIsInner ? 'in app' : 'sign in';

    dispatch({
      type: LANGUAGE_CHANGE,
      payload: {
        language,
        location,
      },
    });

    if (pageIsInner || config.org_id) {
      window.location = path;
    } else {
      history.push(path);
    }
  }
};
